// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --system-ui:
    system-ui, "Segoe UI", Roboto, Helvetica, Arial, sans-serif,
    "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  --bg: "white";
  --text-color: "black";
}

body {
  min-height: 100lvh;
  background-color: var(--bg);
  color: var(--text-color);

  display: flex;
  justify-content: center;
}

.weather-container {
  display: flex;
  flex-direction: column;
}

.weather-container form {
  display: flex;
  gap: 5px
}

.weather-result {
  display: flex;
  flex-direction: column;
}

.weather-result .location,
.weather-result .currentCondition,
.weather-result .currentTemp
 {
  font-weight: bold;
  font-size: 1.5rem;
}

.weather-result .currentTemp {
  font-weight: bold;
  font-size: 1.5rem;
}
.weather-result .currentTempMin::before {
  content: 'Min: ';
}
.weather-result .currentTempMax::before {
  content: 'Max: ';
}

#loading-screen {
  font-size: 1.2rem;
  font-style: italic;
  border: 0;
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 0.5);
  /* color: var(--text-color); */
  margin: auto;
}`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;EACE;;4DAE0D;EAC1D,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,wBAAwB;;EAExB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;;;;EAIE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,mBAAmB;EACnB,0CAA0C;EAC1C,8BAA8B;EAC9B,YAAY;AACd","sourcesContent":[":root {\n  --system-ui:\n    system-ui, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif,\n    \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\";\n  --bg: \"white\";\n  --text-color: \"black\";\n}\n\nbody {\n  min-height: 100lvh;\n  background-color: var(--bg);\n  color: var(--text-color);\n\n  display: flex;\n  justify-content: center;\n}\n\n.weather-container {\n  display: flex;\n  flex-direction: column;\n}\n\n.weather-container form {\n  display: flex;\n  gap: 5px\n}\n\n.weather-result {\n  display: flex;\n  flex-direction: column;\n}\n\n.weather-result .location,\n.weather-result .currentCondition,\n.weather-result .currentTemp\n {\n  font-weight: bold;\n  font-size: 1.5rem;\n}\n\n.weather-result .currentTemp {\n  font-weight: bold;\n  font-size: 1.5rem;\n}\n.weather-result .currentTempMin::before {\n  content: 'Min: ';\n}\n.weather-result .currentTempMax::before {\n  content: 'Max: ';\n}\n\n#loading-screen {\n  font-size: 1.2rem;\n  font-style: italic;\n  border: 0;\n  border-radius: 10px;\n  background-color: rgba(255, 255, 255, 0.5);\n  /* color: var(--text-color); */\n  margin: auto;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
